export const calculateBMI = (height, weight) => {
  const heightInMeters = height / 100;

  const bmi = weight / (heightInMeters * heightInMeters);

  if (bmi === Infinity) return null;

  return Math.round(bmi * 100) / 100;
};
